import React, {
  useState,
  forwardRef,
  useImperativeHandle,
} from "react";
import Autocomplete from "@mui/material/Autocomplete";
import { Card, CardContent, Grid, FormControl, TextField, Typography } from "@mui/material";

const UserInfo = forwardRef(({ selectedFilters, setSelectedFilters }, ref) => {
  const [advancedFilters] = useState([
    "Begins with",
    "Equals",
    "Contains",
    "Ends With",
  ]);

  const handleChange = (filterName, newValue, filterType) => {
    if (filterName.endsWith('Filter')) {
      // For filter type dropdowns
      const filterTypeValue = getFilterTypeValue(newValue);
      const baseFilterName = filterName.replace('Filter', '');
      setSelectedFilters((prevFilters) => ({
        ...prevFilters,
        [filterName]: { label: newValue, value: filterTypeValue },
        [baseFilterName]: {
          value: prevFilters[baseFilterName]?.value || "",
          label: prevFilters[baseFilterName]?.label || "",
          filterType: filterTypeValue,
        },
      }));
    } else {
      // For text input fields
      setSelectedFilters((prevFilters) => ({
        ...prevFilters,
        [filterName]: {
          value: newValue.toUpperCase(),
          label: newValue.trim().toUpperCase(),
          filterType: filterType || "startsWith", 
        },
      }));
    }
  };

  const getFilterTypeValue = (label) => {
    switch (label) {
      case "Begins with":
        return "startsWith";
      case "Equals":
        return "equals";
      case "Contains":
        return "contains";
      case "Ends With":
        return "endsWith";
      default:
        return "startsWith";
    }
  };

  const filterNames4 = [
    "First Name",
    "Last Name",
    "House Number",
    "Street Name",
    "City",
    "Zip",
  ];

  useImperativeHandle(ref, () => ({
    handleRefreshFilter() {},
  }));

  return (
    <div>
      <Card elevation={3} className="m-2 sm:m-4">
        <CardContent>
          <Typography variant="h6" className="mb-3 pt-3 pb-3">
            Address Filters
          </Typography>
          <Grid container spacing={2}>
            {filterNames4.map((filter, index) => (
              <React.Fragment key={index}>
                <Grid item xs={6} md={6}>
                  <FormControl variant="outlined" fullWidth>
                    <Autocomplete
                      options={advancedFilters}
                      value={selectedFilters[`selected${filter.replace(/\s/g, "")}Filter`]?.label || null}
                      onChange={(_, newValue) =>
                        handleChange(
                          `selected${filter.replace(/\s/g, "")}Filter`,
                          newValue
                        )
                      }
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label={`Begin With ${filter} filter`}
                          variant="outlined"
                        />
                      )}
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={6} md={6}>
                  <FormControl variant="outlined" fullWidth>
                    <TextField
                      label={`Search for ${filter}`}
                      variant="outlined"
                      value={
                        selectedFilters[`selected${filter.replace(/\s/g, "")}`]?.value || ""  
                      }
                      onChange={(e) =>
                        handleChange(
                          `selected${filter.replace(/\s/g, "")}`,
                          e.target.value,
                          selectedFilters[
                            `selected${filter.replace(/\s/g, "")}Filter`
                          ]?.value
                        )
                      }
                    />
                  </FormControl>
                </Grid>
              </React.Fragment>
            ))}
          </Grid>
        </CardContent>
      </Card>
    </div>
  );
});

export default UserInfo;
